export const SET_HEADER_TITLE = 'SET_HEADER_TITLE';
export const SET_CURRENT_PROJECT = 'SET_CURRENT_PROJECT';
export const CUSTOMER_ASK_SOMETHING = 'CUSTOMER_ASK_SOMETHING';
export const SET_HIGHLIGHT_NOTIFICATION = 'SET_HIGHLIGHT_NOTIFICATION';
export const CUSTOMER_AREA_INITIATED = 'CUSTOMER_AREA_INITIATED';
export const SELECT_CURRENT_PROJECT = 'SELECT_CURRENT_PROJECT';
export const CURRENT_PROJECT_INITIATED = 'CURRENT_PROJECT_INITIATED';
export const PROCESS_OPTIONS = 'PROCESS_OPTIONS';
export const EDIT_PROCESS_OPTIONS = 'EDIT_PROCESS_OPTIONS';
export const PROCESS_OPTIONS_PERSISTED = 'PROCESS_OPTIONS_PERSISTED';
export const PROCESS_OPTIONS_PERSISTING = 'PROCESS_OPTIONS_PERSISTING';
